var React = require('react');

function ArrowNext (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.5302 1.35352L27.4142 9.23752L19.5302 17.1215","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M27.414 9.2373H0","strokeWidth":"1.5","key":1})]);
}

ArrowNext.defaultProps = {"width":"29","height":"18","viewBox":"0 0 29 18","fill":"none"};

module.exports = ArrowNext;

ArrowNext.default = ArrowNext;
